import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'

export const isDocType = (eltType: EltType) => {
  return (
    eltType === EltType.Doc || eltType === EltType.DocOctober25 || eltType === EltType.DocJanuary26
  )
}
